import { AxiosResponseHeaders } from 'axios';
import { isEmpty } from '@dxb-web-ui-framework/common/utils/Helper';
import { Country, CountryResponseDTO } from '../entities';

const countryDTOToCountryAdapter = (data: CountryResponseDTO, headers?: AxiosResponseHeaders): Country[] => {
  if (!data.body) {
    throw new Error('Error');
  }

  const { countries } = data.body;

  if (isEmpty(countries)) {
    return [];
  }

  return countries;
};

export { countryDTOToCountryAdapter };
